module.exports = new __parcel__URL__("longsleeve_blk.2589e4cf.jpg").toString();